import { useQuery, type QueryClient } from '@tanstack/react-query';

import { AuditFormService } from '#apps/client-web/features/audit-form/services/audit-form';
import { AUDIT_FORMS_QUERY_KEY } from '#apps/client-web/features/audit-form/types/react-query';

import { type AuditId } from '#packages/data-collection/models/audit';
import {
  type AuditForm,
  type AuditFormType,
} from '#packages/data-collection/models/audit-form';

export const useLoadAuditFormByType = <T extends AuditForm>({
  auditFormService,
  queryClient,
  auditId,
  formType,
}: {
  auditFormService: AuditFormService;
  queryClient: QueryClient;
  auditId: AuditId;
  formType: AuditFormType;
}) =>
  useQuery(
    {
      queryKey: [AUDIT_FORMS_QUERY_KEY, auditId, formType],
      queryFn: () =>
        auditFormService.loadByType({
          auditId,
          formType,
        }) as Promise<T | null>,
    },
    queryClient,
  );
